
export const pickingCapacityByDispatchType = {
    searchText: 'Buscar ...',
    export: false,
    filter: false,
    checkbox: true,
    show: 'Aun no hay capacidades que mostrar', 
    iconsOfActions: [
        {
            icon: 'cancel',
            tooltip: 'Eliminar capacidad'
        }, 
        {
            icon: 'edit', 
            tooltip: 'Editar capacidad',
            hasVisibleCondition: (element: any[]): boolean => {
                return element && element.length && element.length <= 1 ? true : false;
            }
        },
        {
            icon: 'exception-days', 
            tooltip: 'Agregar excepción'
        },
        {
            icon: 'calendar', 
            tooltip: 'Agregar excepción de feriados'
        }
    ],
    columns: [
        {
            title: 'Tipo de despacho',
            name: 'dispatchTypeCode',
            type: 'string',
            class: 'left',
            value: (element: any) => element.dispatchTypeCode
        },
        {
            title: 'Capacidad',
            name: 'capacityValue',
            type: 'string',
            class: 'left',
            value: (element: any) => element.capacityValue
        },
        {
            title: 'Rango horario',
            name: 'timeRange',
            type: 'string',
            class: 'left',
            value: (element: any) => element.pickingDays
        },
        {
            title: 'Códigos Vtex',
            name: 'vtexCodeList',
            type: 'string',
            class: 'left',
            value: (element: any) => element.vtexCodeList && element.vtexCodeList.length > 0 ? element.vtexCodeList.map((item) => item.vtexCode): ''
        },
        {
            title: 'Tiene excepciones',
            name: 'exception',
            type: 'string',
            class: 'left',
            value: (element: any) => element.capacityException && element.capacityException.length > 0 ? 'SI': 'NO'
        }
       
    ]
};
